/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  queryOptions as queryOptionsBuilder,
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  CreatePerson,
  EmptyTreeInfo,
  GetCollectivesTreeParams,
  GetPersonDataContactPermissions200One,
  GetPersonDataContactPermissions200Three,
  GetPersonDataContactPermissions200Two,
  GetPersonDataContactPermissionsParams,
  GetPersonFinanceDtoParams,
  GetPersonFinancePermissionTypeParams,
  GetPersonParams,
  GetPersonsByIdsParams,
  GetPersonsWithSameNameParams,
  GetSearchNameParams,
  GetSimplePersonForContractParams,
  GetSimplePersonParams,
  GetSimplePersonsByIdsParams,
  GetSimplePersonsParams,
  GetUpdatePersonDetailsDtoParams,
  PaginatedPersonsRequest,
  PermissionType,
  PersonDto,
  PersonDtoPagination,
  PersonFinanceDto,
  SimplePerson,
  SimplePersonPagination,
  UpdatePersonDetailsDto
} from '../../model';

import { customInstance } from '../../../mutator.ts';
import type { ErrorType , BodyType } from '../../../mutator.ts';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getGetSimplePersonUrl = (params?: GetSimplePersonParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetSimplePerson?${stringifiedParams}` : `/api/Person/GetSimplePerson`
}

export const getSimplePerson = async (params?: GetSimplePersonParams, options?: Parameters<typeof customInstance>[1]): Promise<SimplePerson> => {

  return customInstance<SimplePerson>(getGetSimplePersonUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSimplePersonQueryKey = (params?: GetSimplePersonParams,) => {
    return [
    `/api/Person/GetSimplePerson`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSimplePersonQueryOptions = <TData = Awaited<ReturnType<typeof getSimplePerson>>, TError = ErrorType<unknown>>(params?: GetSimplePersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimplePersonQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimplePerson>>> = ({ signal }) => getSimplePerson(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimplePerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSimplePersonQueryResult = NonNullable<Awaited<ReturnType<typeof getSimplePerson>>>
export type GetSimplePersonQueryError = ErrorType<unknown>


export function useGetSimplePerson<TData = Awaited<ReturnType<typeof getSimplePerson>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimplePersonParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePerson>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimplePerson>>,
          TError,
          Awaited<ReturnType<typeof getSimplePerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimplePerson<TData = Awaited<ReturnType<typeof getSimplePerson>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePerson>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimplePerson>>,
          TError,
          Awaited<ReturnType<typeof getSimplePerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimplePerson<TData = Awaited<ReturnType<typeof getSimplePerson>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimplePerson<TData = Awaited<ReturnType<typeof getSimplePerson>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimplePersonQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSimplePersonSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSimplePerson>>, TError = ErrorType<unknown>>(params?: GetSimplePersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimplePersonQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimplePerson>>> = ({ signal }) => getSimplePerson(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSimplePersonSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSimplePerson>>>
export type GetSimplePersonSuspenseQueryError = ErrorType<unknown>


export function useGetSimplePersonSuspense<TData = Awaited<ReturnType<typeof getSimplePerson>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimplePersonParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimplePersonSuspense<TData = Awaited<ReturnType<typeof getSimplePerson>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimplePersonSuspense<TData = Awaited<ReturnType<typeof getSimplePerson>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimplePersonSuspense<TData = Awaited<ReturnType<typeof getSimplePerson>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimplePersonSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSimplePersonForContractUrl = (params?: GetSimplePersonForContractParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetSimplePersonForContract?${stringifiedParams}` : `/api/Person/GetSimplePersonForContract`
}

export const getSimplePersonForContract = async (params?: GetSimplePersonForContractParams, options?: Parameters<typeof customInstance>[1]): Promise<SimplePerson> => {

  return customInstance<SimplePerson>(getGetSimplePersonForContractUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSimplePersonForContractQueryKey = (params?: GetSimplePersonForContractParams,) => {
    return [
    `/api/Person/GetSimplePersonForContract`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSimplePersonForContractQueryOptions = <TData = Awaited<ReturnType<typeof getSimplePersonForContract>>, TError = ErrorType<unknown>>(params?: GetSimplePersonForContractParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePersonForContract>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimplePersonForContractQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimplePersonForContract>>> = ({ signal }) => getSimplePersonForContract(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimplePersonForContract>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSimplePersonForContractQueryResult = NonNullable<Awaited<ReturnType<typeof getSimplePersonForContract>>>
export type GetSimplePersonForContractQueryError = ErrorType<unknown>


export function useGetSimplePersonForContract<TData = Awaited<ReturnType<typeof getSimplePersonForContract>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimplePersonForContractParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePersonForContract>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimplePersonForContract>>,
          TError,
          Awaited<ReturnType<typeof getSimplePersonForContract>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimplePersonForContract<TData = Awaited<ReturnType<typeof getSimplePersonForContract>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonForContractParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePersonForContract>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimplePersonForContract>>,
          TError,
          Awaited<ReturnType<typeof getSimplePersonForContract>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimplePersonForContract<TData = Awaited<ReturnType<typeof getSimplePersonForContract>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonForContractParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePersonForContract>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimplePersonForContract<TData = Awaited<ReturnType<typeof getSimplePersonForContract>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonForContractParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePersonForContract>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimplePersonForContractQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSimplePersonForContractSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSimplePersonForContract>>, TError = ErrorType<unknown>>(params?: GetSimplePersonForContractParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersonForContract>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimplePersonForContractQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimplePersonForContract>>> = ({ signal }) => getSimplePersonForContract(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersonForContract>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSimplePersonForContractSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSimplePersonForContract>>>
export type GetSimplePersonForContractSuspenseQueryError = ErrorType<unknown>


export function useGetSimplePersonForContractSuspense<TData = Awaited<ReturnType<typeof getSimplePersonForContract>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimplePersonForContractParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersonForContract>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimplePersonForContractSuspense<TData = Awaited<ReturnType<typeof getSimplePersonForContract>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonForContractParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersonForContract>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimplePersonForContractSuspense<TData = Awaited<ReturnType<typeof getSimplePersonForContract>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonForContractParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersonForContract>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimplePersonForContractSuspense<TData = Awaited<ReturnType<typeof getSimplePersonForContract>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonForContractParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersonForContract>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimplePersonForContractSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPersonUrl = (params?: GetPersonParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetPerson?${stringifiedParams}` : `/api/Person/GetPerson`
}

export const getPerson = async (params?: GetPersonParams, options?: Parameters<typeof customInstance>[1]): Promise<PersonDto> => {

  return customInstance<PersonDto>(getGetPersonUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPersonQueryKey = (params?: GetPersonParams,) => {
    return [
    `/api/Person/GetPerson`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPersonQueryOptions = <TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<unknown>>(params?: GetPersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerson>>> = ({ signal }) => getPerson(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonQueryResult = NonNullable<Awaited<ReturnType<typeof getPerson>>>
export type GetPersonQueryError = ErrorType<unknown>


export function useGetPerson<TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPersonParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerson>>,
          TError,
          Awaited<ReturnType<typeof getPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerson<TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<unknown>>(
 params?: GetPersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPerson>>,
          TError,
          Awaited<ReturnType<typeof getPerson>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPerson<TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<unknown>>(
 params?: GetPersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPerson<TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<unknown>>(
 params?: GetPersonParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPersonSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<unknown>>(params?: GetPersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPerson>>> = ({ signal }) => getPerson(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPersonSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPerson>>>
export type GetPersonSuspenseQueryError = ErrorType<unknown>


export function useGetPersonSuspense<TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPersonParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonSuspense<TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<unknown>>(
 params?: GetPersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonSuspense<TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<unknown>>(
 params?: GetPersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPersonSuspense<TData = Awaited<ReturnType<typeof getPerson>>, TError = ErrorType<unknown>>(
 params?: GetPersonParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPerson>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPersonsByIdsUrl = (params?: GetPersonsByIdsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["ids"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetPersonsByIds?${stringifiedParams}` : `/api/Person/GetPersonsByIds`
}

export const getPersonsByIds = async (params?: GetPersonsByIdsParams, options?: Parameters<typeof customInstance>[1]): Promise<PersonDto[]> => {

  return customInstance<PersonDto[]>(getGetPersonsByIdsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPersonsByIdsQueryKey = (params?: GetPersonsByIdsParams,) => {
    return [
    `/api/Person/GetPersonsByIds`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPersonsByIdsQueryOptions = <TData = Awaited<ReturnType<typeof getPersonsByIds>>, TError = ErrorType<unknown>>(params?: GetPersonsByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonsByIdsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonsByIds>>> = ({ signal }) => getPersonsByIds(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonsByIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonsByIdsQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonsByIds>>>
export type GetPersonsByIdsQueryError = ErrorType<unknown>


export function useGetPersonsByIds<TData = Awaited<ReturnType<typeof getPersonsByIds>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPersonsByIdsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonsByIds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonsByIds>>,
          TError,
          Awaited<ReturnType<typeof getPersonsByIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonsByIds<TData = Awaited<ReturnType<typeof getPersonsByIds>>, TError = ErrorType<unknown>>(
 params?: GetPersonsByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonsByIds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonsByIds>>,
          TError,
          Awaited<ReturnType<typeof getPersonsByIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonsByIds<TData = Awaited<ReturnType<typeof getPersonsByIds>>, TError = ErrorType<unknown>>(
 params?: GetPersonsByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPersonsByIds<TData = Awaited<ReturnType<typeof getPersonsByIds>>, TError = ErrorType<unknown>>(
 params?: GetPersonsByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonsByIdsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPersonsByIdsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPersonsByIds>>, TError = ErrorType<unknown>>(params?: GetPersonsByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonsByIdsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonsByIds>>> = ({ signal }) => getPersonsByIds(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonsByIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPersonsByIdsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonsByIds>>>
export type GetPersonsByIdsSuspenseQueryError = ErrorType<unknown>


export function useGetPersonsByIdsSuspense<TData = Awaited<ReturnType<typeof getPersonsByIds>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPersonsByIdsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonsByIdsSuspense<TData = Awaited<ReturnType<typeof getPersonsByIds>>, TError = ErrorType<unknown>>(
 params?: GetPersonsByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonsByIdsSuspense<TData = Awaited<ReturnType<typeof getPersonsByIds>>, TError = ErrorType<unknown>>(
 params?: GetPersonsByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPersonsByIdsSuspense<TData = Awaited<ReturnType<typeof getPersonsByIds>>, TError = ErrorType<unknown>>(
 params?: GetPersonsByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonsByIdsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSimplePersonsByIdsUrl = (params: GetSimplePersonsByIdsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["ids"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetSimplePersonsByIds?${stringifiedParams}` : `/api/Person/GetSimplePersonsByIds`
}

export const getSimplePersonsByIds = async (params: GetSimplePersonsByIdsParams, options?: Parameters<typeof customInstance>[1]): Promise<SimplePerson[]> => {

  return customInstance<SimplePerson[]>(getGetSimplePersonsByIdsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSimplePersonsByIdsQueryKey = (params?: GetSimplePersonsByIdsParams,) => {
    return [
    `/api/Person/GetSimplePersonsByIds`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSimplePersonsByIdsQueryOptions = <TData = Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError = ErrorType<unknown>>(params: GetSimplePersonsByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimplePersonsByIdsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimplePersonsByIds>>> = ({ signal }) => getSimplePersonsByIds(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSimplePersonsByIdsQueryResult = NonNullable<Awaited<ReturnType<typeof getSimplePersonsByIds>>>
export type GetSimplePersonsByIdsQueryError = ErrorType<unknown>


export function useGetSimplePersonsByIds<TData = Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError = ErrorType<unknown>>(
 params: GetSimplePersonsByIdsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimplePersonsByIds>>,
          TError,
          Awaited<ReturnType<typeof getSimplePersonsByIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimplePersonsByIds<TData = Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError = ErrorType<unknown>>(
 params: GetSimplePersonsByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimplePersonsByIds>>,
          TError,
          Awaited<ReturnType<typeof getSimplePersonsByIds>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimplePersonsByIds<TData = Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError = ErrorType<unknown>>(
 params: GetSimplePersonsByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimplePersonsByIds<TData = Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError = ErrorType<unknown>>(
 params: GetSimplePersonsByIdsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimplePersonsByIdsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSimplePersonsByIdsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError = ErrorType<unknown>>(params: GetSimplePersonsByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimplePersonsByIdsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimplePersonsByIds>>> = ({ signal }) => getSimplePersonsByIds(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSimplePersonsByIdsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSimplePersonsByIds>>>
export type GetSimplePersonsByIdsSuspenseQueryError = ErrorType<unknown>


export function useGetSimplePersonsByIdsSuspense<TData = Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError = ErrorType<unknown>>(
 params: GetSimplePersonsByIdsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimplePersonsByIdsSuspense<TData = Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError = ErrorType<unknown>>(
 params: GetSimplePersonsByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimplePersonsByIdsSuspense<TData = Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError = ErrorType<unknown>>(
 params: GetSimplePersonsByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimplePersonsByIdsSuspense<TData = Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError = ErrorType<unknown>>(
 params: GetSimplePersonsByIdsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersonsByIds>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimplePersonsByIdsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPaginatedPersonsUrl = () => {




  return `/api/Person/GetPaginatedPersons`
}

export const getPaginatedPersons = async (paginatedPersonsRequest: PaginatedPersonsRequest, options?: Parameters<typeof customInstance>[1]): Promise<PersonDtoPagination> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<PersonDtoPagination>(getGetPaginatedPersonsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(paginatedPersonsRequest)
  }
);}





export const getGetPaginatedPersonsMutationKey = () => ['getPaginatedPersons'] as const;

export const getGetPaginatedPersonsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPaginatedPersons>>, TError,GetPaginatedPersonsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof getPaginatedPersons>>, TError,GetPaginatedPersonsMutationVariables, TContext> => {

const mutationKey = getGetPaginatedPersonsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof getPaginatedPersons>>, GetPaginatedPersonsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  getPaginatedPersons(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type GetPaginatedPersonsMutationResult = NonNullable<Awaited<ReturnType<typeof getPaginatedPersons>>>
    export type GetPaginatedPersonsMutationBody = BodyType<PaginatedPersonsRequest>
    export type GetPaginatedPersonsMutationError = ErrorType<unknown>
    export type GetPaginatedPersonsMutationVariables = {data: BodyType<PaginatedPersonsRequest>}

    export const useGetPaginatedPersons = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof getPaginatedPersons>>, TError,GetPaginatedPersonsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof getPaginatedPersons>>,
        TError,
        GetPaginatedPersonsMutationVariables,
        TContext
      > => {
      return useMutation(getGetPaginatedPersonsMutationOptions(options), queryClient);
    }
    export const getGetSimplePersonsUrl = (params?: GetSimplePersonsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["workAreaTreeNodes","contractTypeTreeNodes","personCategoryTypes"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetSimplePersons?${stringifiedParams}` : `/api/Person/GetSimplePersons`
}

export const getSimplePersons = async (params?: GetSimplePersonsParams, options?: Parameters<typeof customInstance>[1]): Promise<SimplePersonPagination> => {

  return customInstance<SimplePersonPagination>(getGetSimplePersonsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSimplePersonsQueryKey = (params?: GetSimplePersonsParams,) => {
    return [
    `/api/Person/GetSimplePersons`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSimplePersonsQueryOptions = <TData = Awaited<ReturnType<typeof getSimplePersons>>, TError = ErrorType<unknown>>(params?: GetSimplePersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimplePersonsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimplePersons>>> = ({ signal }) => getSimplePersons(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSimplePersonsQueryResult = NonNullable<Awaited<ReturnType<typeof getSimplePersons>>>
export type GetSimplePersonsQueryError = ErrorType<unknown>


export function useGetSimplePersons<TData = Awaited<ReturnType<typeof getSimplePersons>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimplePersonsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimplePersons>>,
          TError,
          Awaited<ReturnType<typeof getSimplePersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimplePersons<TData = Awaited<ReturnType<typeof getSimplePersons>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSimplePersons>>,
          TError,
          Awaited<ReturnType<typeof getSimplePersons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimplePersons<TData = Awaited<ReturnType<typeof getSimplePersons>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimplePersons<TData = Awaited<ReturnType<typeof getSimplePersons>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimplePersonsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSimplePersonsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSimplePersons>>, TError = ErrorType<unknown>>(params?: GetSimplePersonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSimplePersonsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSimplePersons>>> = ({ signal }) => getSimplePersons(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSimplePersonsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSimplePersons>>>
export type GetSimplePersonsSuspenseQueryError = ErrorType<unknown>


export function useGetSimplePersonsSuspense<TData = Awaited<ReturnType<typeof getSimplePersons>>, TError = ErrorType<unknown>>(
 params: undefined |  GetSimplePersonsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimplePersonsSuspense<TData = Awaited<ReturnType<typeof getSimplePersons>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSimplePersonsSuspense<TData = Awaited<ReturnType<typeof getSimplePersons>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSimplePersonsSuspense<TData = Awaited<ReturnType<typeof getSimplePersons>>, TError = ErrorType<unknown>>(
 params?: GetSimplePersonsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSimplePersons>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSimplePersonsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUpdatePersonDetailsDtoUrl = (params?: GetUpdatePersonDetailsDtoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetUpdatePersonDetailsDto?${stringifiedParams}` : `/api/Person/GetUpdatePersonDetailsDto`
}

export const getUpdatePersonDetailsDto = async (params?: GetUpdatePersonDetailsDtoParams, options?: Parameters<typeof customInstance>[1]): Promise<UpdatePersonDetailsDto> => {

  return customInstance<UpdatePersonDetailsDto>(getGetUpdatePersonDetailsDtoUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetUpdatePersonDetailsDtoQueryKey = (params?: GetUpdatePersonDetailsDtoParams,) => {
    return [
    `/api/Person/GetUpdatePersonDetailsDto`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetUpdatePersonDetailsDtoQueryOptions = <TData = Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError = ErrorType<unknown>>(params?: GetUpdatePersonDetailsDtoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUpdatePersonDetailsDtoQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>> = ({ signal }) => getUpdatePersonDetailsDto(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetUpdatePersonDetailsDtoQueryResult = NonNullable<Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>>
export type GetUpdatePersonDetailsDtoQueryError = ErrorType<unknown>


export function useGetUpdatePersonDetailsDto<TData = Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUpdatePersonDetailsDtoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>,
          TError,
          Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpdatePersonDetailsDto<TData = Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError = ErrorType<unknown>>(
 params?: GetUpdatePersonDetailsDtoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>,
          TError,
          Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpdatePersonDetailsDto<TData = Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError = ErrorType<unknown>>(
 params?: GetUpdatePersonDetailsDtoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUpdatePersonDetailsDto<TData = Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError = ErrorType<unknown>>(
 params?: GetUpdatePersonDetailsDtoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUpdatePersonDetailsDtoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetUpdatePersonDetailsDtoSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError = ErrorType<unknown>>(params?: GetUpdatePersonDetailsDtoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUpdatePersonDetailsDtoQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>> = ({ signal }) => getUpdatePersonDetailsDto(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetUpdatePersonDetailsDtoSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>>
export type GetUpdatePersonDetailsDtoSuspenseQueryError = ErrorType<unknown>


export function useGetUpdatePersonDetailsDtoSuspense<TData = Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError = ErrorType<unknown>>(
 params: undefined |  GetUpdatePersonDetailsDtoParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpdatePersonDetailsDtoSuspense<TData = Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError = ErrorType<unknown>>(
 params?: GetUpdatePersonDetailsDtoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetUpdatePersonDetailsDtoSuspense<TData = Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError = ErrorType<unknown>>(
 params?: GetUpdatePersonDetailsDtoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetUpdatePersonDetailsDtoSuspense<TData = Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError = ErrorType<unknown>>(
 params?: GetUpdatePersonDetailsDtoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getUpdatePersonDetailsDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetUpdatePersonDetailsDtoSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdatePersonDetailsUrl = () => {




  return `/api/Person/UpdatePersonDetails`
}

export const updatePersonDetails = async (updatePersonDetailsDto?: UpdatePersonDetailsDto, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getUpdatePersonDetailsUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(updatePersonDetailsDto)
  }
);}





export const getUpdatePersonDetailsMutationKey = () => ['updatePersonDetails'] as const;

export const getUpdatePersonDetailsMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePersonDetails>>, TError,UpdatePersonDetailsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePersonDetails>>, TError,UpdatePersonDetailsMutationVariables, TContext> => {

const mutationKey = getUpdatePersonDetailsMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePersonDetails>>, UpdatePersonDetailsMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updatePersonDetails(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePersonDetailsMutationResult = NonNullable<Awaited<ReturnType<typeof updatePersonDetails>>>
    export type UpdatePersonDetailsMutationBody = BodyType<UpdatePersonDetailsDto> | undefined
    export type UpdatePersonDetailsMutationError = ErrorType<unknown>
    export type UpdatePersonDetailsMutationVariables = {data?: BodyType<UpdatePersonDetailsDto>}

    export const useUpdatePersonDetails = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePersonDetails>>, TError,UpdatePersonDetailsMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePersonDetails>>,
        TError,
        UpdatePersonDetailsMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePersonDetailsMutationOptions(options), queryClient);
    }
    export const getGetPersonDataContactPermissionsUrl = (params?: GetPersonDataContactPermissionsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["personIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : String(v));
      });
      return;
    }


  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetPersonDataContactPermissions?${stringifiedParams}` : `/api/Person/GetPersonDataContactPermissions`
}

export const getPersonDataContactPermissions = async (params?: GetPersonDataContactPermissionsParams, options?: Parameters<typeof customInstance>[1]): Promise<GetPersonDataContactPermissions200One | GetPersonDataContactPermissions200Two | GetPersonDataContactPermissions200Three> => {

  return customInstance<GetPersonDataContactPermissions200One | GetPersonDataContactPermissions200Two | GetPersonDataContactPermissions200Three>(getGetPersonDataContactPermissionsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPersonDataContactPermissionsQueryKey = (params?: GetPersonDataContactPermissionsParams,) => {
    return [
    `/api/Person/GetPersonDataContactPermissions`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPersonDataContactPermissionsQueryOptions = <TData = Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError = ErrorType<unknown>>(params?: GetPersonDataContactPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonDataContactPermissionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonDataContactPermissions>>> = ({ signal }) => getPersonDataContactPermissions(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonDataContactPermissionsQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonDataContactPermissions>>>
export type GetPersonDataContactPermissionsQueryError = ErrorType<unknown>


export function useGetPersonDataContactPermissions<TData = Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPersonDataContactPermissionsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonDataContactPermissions>>,
          TError,
          Awaited<ReturnType<typeof getPersonDataContactPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonDataContactPermissions<TData = Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError = ErrorType<unknown>>(
 params?: GetPersonDataContactPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonDataContactPermissions>>,
          TError,
          Awaited<ReturnType<typeof getPersonDataContactPermissions>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonDataContactPermissions<TData = Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError = ErrorType<unknown>>(
 params?: GetPersonDataContactPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPersonDataContactPermissions<TData = Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError = ErrorType<unknown>>(
 params?: GetPersonDataContactPermissionsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonDataContactPermissionsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPersonDataContactPermissionsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError = ErrorType<unknown>>(params?: GetPersonDataContactPermissionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonDataContactPermissionsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonDataContactPermissions>>> = ({ signal }) => getPersonDataContactPermissions(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPersonDataContactPermissionsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonDataContactPermissions>>>
export type GetPersonDataContactPermissionsSuspenseQueryError = ErrorType<unknown>


export function useGetPersonDataContactPermissionsSuspense<TData = Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPersonDataContactPermissionsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonDataContactPermissionsSuspense<TData = Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError = ErrorType<unknown>>(
 params?: GetPersonDataContactPermissionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonDataContactPermissionsSuspense<TData = Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError = ErrorType<unknown>>(
 params?: GetPersonDataContactPermissionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPersonDataContactPermissionsSuspense<TData = Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError = ErrorType<unknown>>(
 params?: GetPersonDataContactPermissionsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonDataContactPermissions>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonDataContactPermissionsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getCreatePersonUrl = () => {




  return `/api/Person/CreatePerson`
}

export const createPerson = async (createPersonBody?: CreatePerson, options?: Parameters<typeof customInstance>[1]): Promise<number> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<number>(getCreatePersonUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(createPersonBody)
  }
);}





export const getCreatePersonMutationKey = () => ['createPerson'] as const;

export const getCreatePersonMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerson>>, TError,CreatePersonMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createPerson>>, TError,CreatePersonMutationVariables, TContext> => {

const mutationKey = getCreatePersonMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createPerson>>, CreatePersonMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createPerson(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreatePersonMutationResult = NonNullable<Awaited<ReturnType<typeof createPerson>>>
    export type CreatePersonMutationBody = BodyType<CreatePerson> | undefined
    export type CreatePersonMutationError = ErrorType<unknown>
    export type CreatePersonMutationVariables = {data?: BodyType<CreatePerson>}

    export const useCreatePerson = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createPerson>>, TError,CreatePersonMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createPerson>>,
        TError,
        CreatePersonMutationVariables,
        TContext
      > => {
      return useMutation(getCreatePersonMutationOptions(options), queryClient);
    }
    export const getGetPersonsWithSameNameUrl = (params?: GetPersonsWithSameNameParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetPersonsWithSameName?${stringifiedParams}` : `/api/Person/GetPersonsWithSameName`
}

export const getPersonsWithSameName = async (params?: GetPersonsWithSameNameParams, options?: Parameters<typeof customInstance>[1]): Promise<PersonDto[]> => {

  return customInstance<PersonDto[]>(getGetPersonsWithSameNameUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPersonsWithSameNameQueryKey = (params?: GetPersonsWithSameNameParams,) => {
    return [
    `/api/Person/GetPersonsWithSameName`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPersonsWithSameNameQueryOptions = <TData = Awaited<ReturnType<typeof getPersonsWithSameName>>, TError = ErrorType<unknown>>(params?: GetPersonsWithSameNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonsWithSameName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonsWithSameNameQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonsWithSameName>>> = ({ signal }) => getPersonsWithSameName(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonsWithSameName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonsWithSameNameQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonsWithSameName>>>
export type GetPersonsWithSameNameQueryError = ErrorType<unknown>


export function useGetPersonsWithSameName<TData = Awaited<ReturnType<typeof getPersonsWithSameName>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPersonsWithSameNameParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonsWithSameName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonsWithSameName>>,
          TError,
          Awaited<ReturnType<typeof getPersonsWithSameName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonsWithSameName<TData = Awaited<ReturnType<typeof getPersonsWithSameName>>, TError = ErrorType<unknown>>(
 params?: GetPersonsWithSameNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonsWithSameName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonsWithSameName>>,
          TError,
          Awaited<ReturnType<typeof getPersonsWithSameName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonsWithSameName<TData = Awaited<ReturnType<typeof getPersonsWithSameName>>, TError = ErrorType<unknown>>(
 params?: GetPersonsWithSameNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonsWithSameName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPersonsWithSameName<TData = Awaited<ReturnType<typeof getPersonsWithSameName>>, TError = ErrorType<unknown>>(
 params?: GetPersonsWithSameNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonsWithSameName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonsWithSameNameQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPersonsWithSameNameSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPersonsWithSameName>>, TError = ErrorType<unknown>>(params?: GetPersonsWithSameNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonsWithSameName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonsWithSameNameQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonsWithSameName>>> = ({ signal }) => getPersonsWithSameName(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonsWithSameName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPersonsWithSameNameSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonsWithSameName>>>
export type GetPersonsWithSameNameSuspenseQueryError = ErrorType<unknown>


export function useGetPersonsWithSameNameSuspense<TData = Awaited<ReturnType<typeof getPersonsWithSameName>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPersonsWithSameNameParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonsWithSameName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonsWithSameNameSuspense<TData = Awaited<ReturnType<typeof getPersonsWithSameName>>, TError = ErrorType<unknown>>(
 params?: GetPersonsWithSameNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonsWithSameName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonsWithSameNameSuspense<TData = Awaited<ReturnType<typeof getPersonsWithSameName>>, TError = ErrorType<unknown>>(
 params?: GetPersonsWithSameNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonsWithSameName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPersonsWithSameNameSuspense<TData = Awaited<ReturnType<typeof getPersonsWithSameName>>, TError = ErrorType<unknown>>(
 params?: GetPersonsWithSameNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonsWithSameName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonsWithSameNameSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSearchNameUrl = (params: GetSearchNameParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetSearchName?${stringifiedParams}` : `/api/Person/GetSearchName`
}

export const getSearchName = async (params: GetSearchNameParams, options?: Parameters<typeof customInstance>[1]): Promise<string> => {

  return customInstance<string>(getGetSearchNameUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetSearchNameQueryKey = (params?: GetSearchNameParams,) => {
    return [
    `/api/Person/GetSearchName`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetSearchNameQueryOptions = <TData = Awaited<ReturnType<typeof getSearchName>>, TError = ErrorType<unknown>>(params: GetSearchNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSearchNameQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearchName>>> = ({ signal }) => getSearchName(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getSearchName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetSearchNameQueryResult = NonNullable<Awaited<ReturnType<typeof getSearchName>>>
export type GetSearchNameQueryError = ErrorType<unknown>


export function useGetSearchName<TData = Awaited<ReturnType<typeof getSearchName>>, TError = ErrorType<unknown>>(
 params: GetSearchNameParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchName>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchName>>,
          TError,
          Awaited<ReturnType<typeof getSearchName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchName<TData = Awaited<ReturnType<typeof getSearchName>>, TError = ErrorType<unknown>>(
 params: GetSearchNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchName>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getSearchName>>,
          TError,
          Awaited<ReturnType<typeof getSearchName>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchName<TData = Awaited<ReturnType<typeof getSearchName>>, TError = ErrorType<unknown>>(
 params: GetSearchNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSearchName<TData = Awaited<ReturnType<typeof getSearchName>>, TError = ErrorType<unknown>>(
 params: GetSearchNameParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getSearchName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSearchNameQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetSearchNameSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getSearchName>>, TError = ErrorType<unknown>>(params: GetSearchNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSearchName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetSearchNameQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getSearchName>>> = ({ signal }) => getSearchName(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSearchName>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetSearchNameSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getSearchName>>>
export type GetSearchNameSuspenseQueryError = ErrorType<unknown>


export function useGetSearchNameSuspense<TData = Awaited<ReturnType<typeof getSearchName>>, TError = ErrorType<unknown>>(
 params: GetSearchNameParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSearchName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchNameSuspense<TData = Awaited<ReturnType<typeof getSearchName>>, TError = ErrorType<unknown>>(
 params: GetSearchNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSearchName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetSearchNameSuspense<TData = Awaited<ReturnType<typeof getSearchName>>, TError = ErrorType<unknown>>(
 params: GetSearchNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSearchName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetSearchNameSuspense<TData = Awaited<ReturnType<typeof getSearchName>>, TError = ErrorType<unknown>>(
 params: GetSearchNameParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getSearchName>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetSearchNameSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPersonFinanceDtoUrl = (params?: GetPersonFinanceDtoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetPersonFinanceDto?${stringifiedParams}` : `/api/Person/GetPersonFinanceDto`
}

export const getPersonFinanceDto = async (params?: GetPersonFinanceDtoParams, options?: Parameters<typeof customInstance>[1]): Promise<PersonFinanceDto> => {

  return customInstance<PersonFinanceDto>(getGetPersonFinanceDtoUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPersonFinanceDtoQueryKey = (params?: GetPersonFinanceDtoParams,) => {
    return [
    `/api/Person/GetPersonFinanceDto`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPersonFinanceDtoQueryOptions = <TData = Awaited<ReturnType<typeof getPersonFinanceDto>>, TError = ErrorType<unknown>>(params?: GetPersonFinanceDtoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonFinanceDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonFinanceDtoQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonFinanceDto>>> = ({ signal }) => getPersonFinanceDto(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonFinanceDto>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonFinanceDtoQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonFinanceDto>>>
export type GetPersonFinanceDtoQueryError = ErrorType<unknown>


export function useGetPersonFinanceDto<TData = Awaited<ReturnType<typeof getPersonFinanceDto>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPersonFinanceDtoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonFinanceDto>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonFinanceDto>>,
          TError,
          Awaited<ReturnType<typeof getPersonFinanceDto>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonFinanceDto<TData = Awaited<ReturnType<typeof getPersonFinanceDto>>, TError = ErrorType<unknown>>(
 params?: GetPersonFinanceDtoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonFinanceDto>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonFinanceDto>>,
          TError,
          Awaited<ReturnType<typeof getPersonFinanceDto>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonFinanceDto<TData = Awaited<ReturnType<typeof getPersonFinanceDto>>, TError = ErrorType<unknown>>(
 params?: GetPersonFinanceDtoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonFinanceDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPersonFinanceDto<TData = Awaited<ReturnType<typeof getPersonFinanceDto>>, TError = ErrorType<unknown>>(
 params?: GetPersonFinanceDtoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonFinanceDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonFinanceDtoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPersonFinanceDtoSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPersonFinanceDto>>, TError = ErrorType<unknown>>(params?: GetPersonFinanceDtoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonFinanceDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonFinanceDtoQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonFinanceDto>>> = ({ signal }) => getPersonFinanceDto(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonFinanceDto>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPersonFinanceDtoSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonFinanceDto>>>
export type GetPersonFinanceDtoSuspenseQueryError = ErrorType<unknown>


export function useGetPersonFinanceDtoSuspense<TData = Awaited<ReturnType<typeof getPersonFinanceDto>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPersonFinanceDtoParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonFinanceDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonFinanceDtoSuspense<TData = Awaited<ReturnType<typeof getPersonFinanceDto>>, TError = ErrorType<unknown>>(
 params?: GetPersonFinanceDtoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonFinanceDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonFinanceDtoSuspense<TData = Awaited<ReturnType<typeof getPersonFinanceDto>>, TError = ErrorType<unknown>>(
 params?: GetPersonFinanceDtoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonFinanceDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPersonFinanceDtoSuspense<TData = Awaited<ReturnType<typeof getPersonFinanceDto>>, TError = ErrorType<unknown>>(
 params?: GetPersonFinanceDtoParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonFinanceDto>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonFinanceDtoSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getUpdatePersonFinanceUrl = () => {




  return `/api/Person/UpdatePersonFinance`
}

export const updatePersonFinance = async (personFinanceDto?: PersonFinanceDto, options?: Parameters<typeof customInstance>[1]): Promise<void> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return customInstance<void>(getUpdatePersonFinanceUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(personFinanceDto)
  }
);}





export const getUpdatePersonFinanceMutationKey = () => ['updatePersonFinance'] as const;

export const getUpdatePersonFinanceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePersonFinance>>, TError,UpdatePersonFinanceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updatePersonFinance>>, TError,UpdatePersonFinanceMutationVariables, TContext> => {

const mutationKey = getUpdatePersonFinanceMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updatePersonFinance>>, UpdatePersonFinanceMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  updatePersonFinance(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdatePersonFinanceMutationResult = NonNullable<Awaited<ReturnType<typeof updatePersonFinance>>>
    export type UpdatePersonFinanceMutationBody = BodyType<PersonFinanceDto> | undefined
    export type UpdatePersonFinanceMutationError = ErrorType<unknown>
    export type UpdatePersonFinanceMutationVariables = {data?: BodyType<PersonFinanceDto>}

    export const useUpdatePersonFinance = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updatePersonFinance>>, TError,UpdatePersonFinanceMutationVariables, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updatePersonFinance>>,
        TError,
        UpdatePersonFinanceMutationVariables,
        TContext
      > => {
      return useMutation(getUpdatePersonFinanceMutationOptions(options), queryClient);
    }
    export const getGetPersonFinancePermissionTypeUrl = (params?: GetPersonFinancePermissionTypeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetPersonFinancePermissionType?${stringifiedParams}` : `/api/Person/GetPersonFinancePermissionType`
}

export const getPersonFinancePermissionType = async (params?: GetPersonFinancePermissionTypeParams, options?: Parameters<typeof customInstance>[1]): Promise<PermissionType> => {

  return customInstance<PermissionType>(getGetPersonFinancePermissionTypeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetPersonFinancePermissionTypeQueryKey = (params?: GetPersonFinancePermissionTypeParams,) => {
    return [
    `/api/Person/GetPersonFinancePermissionType`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetPersonFinancePermissionTypeQueryOptions = <TData = Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError = ErrorType<unknown>>(params?: GetPersonFinancePermissionTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonFinancePermissionTypeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonFinancePermissionType>>> = ({ signal }) => getPersonFinancePermissionType(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetPersonFinancePermissionTypeQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonFinancePermissionType>>>
export type GetPersonFinancePermissionTypeQueryError = ErrorType<unknown>


export function useGetPersonFinancePermissionType<TData = Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPersonFinancePermissionTypeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonFinancePermissionType>>,
          TError,
          Awaited<ReturnType<typeof getPersonFinancePermissionType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonFinancePermissionType<TData = Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError = ErrorType<unknown>>(
 params?: GetPersonFinancePermissionTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPersonFinancePermissionType>>,
          TError,
          Awaited<ReturnType<typeof getPersonFinancePermissionType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonFinancePermissionType<TData = Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError = ErrorType<unknown>>(
 params?: GetPersonFinancePermissionTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPersonFinancePermissionType<TData = Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError = ErrorType<unknown>>(
 params?: GetPersonFinancePermissionTypeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonFinancePermissionTypeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetPersonFinancePermissionTypeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError = ErrorType<unknown>>(params?: GetPersonFinancePermissionTypeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPersonFinancePermissionTypeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPersonFinancePermissionType>>> = ({ signal }) => getPersonFinancePermissionType(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetPersonFinancePermissionTypeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getPersonFinancePermissionType>>>
export type GetPersonFinancePermissionTypeSuspenseQueryError = ErrorType<unknown>


export function useGetPersonFinancePermissionTypeSuspense<TData = Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError = ErrorType<unknown>>(
 params: undefined |  GetPersonFinancePermissionTypeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonFinancePermissionTypeSuspense<TData = Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError = ErrorType<unknown>>(
 params?: GetPersonFinancePermissionTypeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetPersonFinancePermissionTypeSuspense<TData = Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError = ErrorType<unknown>>(
 params?: GetPersonFinancePermissionTypeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetPersonFinancePermissionTypeSuspense<TData = Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError = ErrorType<unknown>>(
 params?: GetPersonFinancePermissionTypeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getPersonFinancePermissionType>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetPersonFinancePermissionTypeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCollectivesTreeUrl = (params?: GetCollectivesTreeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/Person/GetCollectivesTree?${stringifiedParams}` : `/api/Person/GetCollectivesTree`
}

export const getCollectivesTree = async (params?: GetCollectivesTreeParams, options?: Parameters<typeof customInstance>[1]): Promise<EmptyTreeInfo> => {

  return customInstance<EmptyTreeInfo>(getGetCollectivesTreeUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getGetCollectivesTreeQueryKey = (params?: GetCollectivesTreeParams,) => {
    return [
    `/api/Person/GetCollectivesTree`, ...(params ? [params] : [])
    ] as const;
    }


export const getGetCollectivesTreeQueryOptions = <TData = Awaited<ReturnType<typeof getCollectivesTree>>, TError = ErrorType<unknown>>(params?: GetCollectivesTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollectivesTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCollectivesTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCollectivesTree>>> = ({ signal }) => getCollectivesTree(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCollectivesTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetCollectivesTreeQueryResult = NonNullable<Awaited<ReturnType<typeof getCollectivesTree>>>
export type GetCollectivesTreeQueryError = ErrorType<unknown>


export function useGetCollectivesTree<TData = Awaited<ReturnType<typeof getCollectivesTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetCollectivesTreeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollectivesTree>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectivesTree>>,
          TError,
          Awaited<ReturnType<typeof getCollectivesTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCollectivesTree<TData = Awaited<ReturnType<typeof getCollectivesTree>>, TError = ErrorType<unknown>>(
 params?: GetCollectivesTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollectivesTree>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCollectivesTree>>,
          TError,
          Awaited<ReturnType<typeof getCollectivesTree>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCollectivesTree<TData = Awaited<ReturnType<typeof getCollectivesTree>>, TError = ErrorType<unknown>>(
 params?: GetCollectivesTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollectivesTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCollectivesTree<TData = Awaited<ReturnType<typeof getCollectivesTree>>, TError = ErrorType<unknown>>(
 params?: GetCollectivesTreeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCollectivesTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCollectivesTreeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getGetCollectivesTreeSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof getCollectivesTree>>, TError = ErrorType<unknown>>(params?: GetCollectivesTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCollectivesTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCollectivesTreeQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCollectivesTree>>> = ({ signal }) => getCollectivesTree(params, { signal, ...requestOptions });





   return  queryOptionsBuilder({ queryKey, ...queryOptions, queryFn: queryOptions?.queryFn ?? queryFn}) as UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCollectivesTree>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> } & { throwOnError?: ((this: never, error: TError) => boolean) & { readonly __inferenceOnly: never } }
}

export type GetCollectivesTreeSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getCollectivesTree>>>
export type GetCollectivesTreeSuspenseQueryError = ErrorType<unknown>


export function useGetCollectivesTreeSuspense<TData = Awaited<ReturnType<typeof getCollectivesTree>>, TError = ErrorType<unknown>>(
 params: undefined |  GetCollectivesTreeParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCollectivesTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCollectivesTreeSuspense<TData = Awaited<ReturnType<typeof getCollectivesTree>>, TError = ErrorType<unknown>>(
 params?: GetCollectivesTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCollectivesTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetCollectivesTreeSuspense<TData = Awaited<ReturnType<typeof getCollectivesTree>>, TError = ErrorType<unknown>>(
 params?: GetCollectivesTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCollectivesTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetCollectivesTreeSuspense<TData = Awaited<ReturnType<typeof getCollectivesTree>>, TError = ErrorType<unknown>>(
 params?: GetCollectivesTreeParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getCollectivesTree>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetCollectivesTreeSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






